import { ChatEvaluationTestPage } from '@/Workspaces/ChatEvaluationTestSet/Evaluation/ChatEvaluationTestPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ChatEvaluationTestPage />
  )
}
